
<script setup lang="ts">
</script>

<template>
    <div>Report index</div>
</template>